import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCClockEditForm from "./tc-clock-edit/tc-clock-edit-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import { browserHistory } from "react-router";

export default class SupervisorTCClockEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weekEndings: [],
            selectedTimecardId: null,
            selectedWeekEnding: null,
            timecard: null,
            hideButtonPanel: true,
            buttons: "",
            errors: [],
            isIncomplete: false
        }

        this.openRole = context.getRouteParam(this, "role");
        this.statusCode = null;

        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.prepareButtonPanel = this.prepareButtonPanel.bind(this);
        this.onVerify = this.onVerify.bind(this);
    }

    onLoadTimecardCompleted(tc, errors) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecard = tc;
        clone.timecardId = tc.timecardId;
        clone.weekEnding = moment(tc.weekEnding).format("MM-DD-YYYY");
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        clone.isIncomplete = this.refs.tcClockEditForm.isIncomplete();
        clone.errors = (errors == null) ? [] : errors;
        this.statusCode = tc.statusCode.toLowerCase();
        this.setState(clone);
    }

    componentDidMount() {
        this.loadPage();
    }

    onVerify() {
        const hasUnapprovedPto = this.refs.tcClockEditForm.refs.miscList.hasUnapprovedPto();
        if (hasUnapprovedPto)
            return false;

        context.message({
            show: true,
            type: "loading",
            message: "Processing. Please wait...",
        });

        let self = this;
        const timecardId = this.state.timecard.timecardId;
        let newNotes = this.refs.tcClockEditForm.refs.tcSummary.getNotes().trim();
        let submitted = this.statusCode == "saved" ? 0 : 1;
        ajax.api()
            .put(`add-notes/${timecardId}`, { role: self.openRole, notes: newNotes })
            .then(function (res) {
                const preurl = context.routeUrl(`${self.openRole}/tc-clock-edit/${timecardId}`);
                const url = context.appRoot();
                ajax.api()
                    .post("prepare-timecard-verification", {
                        timecards: [timecardId],
                        submitted: submitted,
                        mainUrl: preurl,
                        performValidation: true
                    })
                    .then(function (res) {
                        const data = res.data[0];

                        if (data.errorMessages.length > 0) {
                            setTimeout(() => context.message({ show: false }), 1);
                        } else {
                            const redirect = () => {
                                browserHistory.push(context.routeUrl(`${self.openRole}/tc-approval/${submitted}`));
                            };
                            if (data.warningMessages.length > 0) {
                                let liKey = 0;
                                context.message({
                                    show: true,
                                    type: 'warning',
                                    message: <div>
                                        <ul>
                                            {data.warningMessages.map(w => <li key={liKey++}>{w}</li>)}
                                        </ul>
                                        <p>
                                            Are you sure to verify this timecard?
                                </p>
                                    </div>,
                                    buttons: "yes,no"
                                }, function (button, s) {
                                    if (button == "yes") {
                                        context.message({
                                            show: true,
                                            type: "loading",
                                            message: "Processing. Please wait...",
                                        });
                                        setTimeout(redirect, 1);
                                    } else {
                                        context.message({ show: false });
                                    }
                                });
                            } else redirect();

                        }

                        //window.location = context.root() + `/../Common/ApproveTimecard.aspx?v2=1&token=${res.data}&preurl=${preurl}&url=${url}`;
                        
                    })
                    .catch(function (err) {
                        const clone = immutable.fromJS(self.state).toJS();
                        clone.errors = [];
                        let data = err.response.data;
                        if (data.exceptionMessage.length > 1 || data.message.length > 1) {
                            clone.errors.push(data.exceptionMessage || data.message);
                        } else {
                            for (let k in data.data) {
                                clone.errors.push(data.data[k]);
                            }
                        }
                        context.message({ show: false });
                        self.setState(clone, function () { window.scrollTo(0, 0); });
                    });
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error when attempting to add notes.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    loadPage() {
        const tid = this.props.params.timecardId;
        let self = this;
        // ajax.vm()
        //     .get("people/tc-clock-edit")
        //     .then(function (res) {
        //         const data = res.data;
        //         if (tid) {
        //             for (let i = 0; i < data.weekEndings.length; i++) {
        //                 if (tid == data.weekEndings[i].timecardId) {
        //                     data.selectedTimecardId = data.weekEndings[i].timecardId;
        //                     data.selectedWeekEnding = moment(data.weekEndings[i].weekEnding).format("MM/DD/YYYY");
        //                 }
        //             }
        //         }
        //         console.log(data);
        //         self.setState(data);
        //     });

    }

    prepareButtonPanel(tc) {

        const result = {
            hideButtonPanel: true,
            buttons: ""
        };
        if (tc) {
            const statusCode = tc.statusCode.toLowerCase();
            if (statusCode === "saved" || statusCode === "submitted" || (statusCode === "approved" && tc.approvedDate == null)) {
                result.hideButtonPanel = false;
                result.buttons = "verify";
            }
        }

        return result;
    }

    createNewTimecard() {
        const clone = immutable.fromJS(this.state).toJS();
        clone.selectedTimecardId = -1;
        this.setState(clone);
    }

    render() {
        const buttonPanel = !this.state.hideButtonPanel ?
            <TCButtonPanel buttons={this.state.buttons}
                hidden={this.state.hideButtonPanel}
                onVerify={this.onVerify} /> : null;
        const tc = this.state.timecard;
        let alert = null, errors = null;
        if (this.state.errors.length > 0) {
            errors = <Alert bsStyle="danger"><ul>
                {
                    this.state.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>
        }
        let hideGrid = (tc && moment(tc.weekEnding).endOf("week").format("YYYYMMDD") > moment().endOf("week").format("YYYYMMDD")); // hide if future timecard
        let allowEdit = true;
        if (tc
            && tc.statusCode.toLowerCase() !== "saved"
            && tc.statusCode.toLowerCase() !== "submitted"
            && (tc.preapprovedDate != null || tc.approvedDate != null)) {

            allowEdit = false;
            if (tc.approvedDate != null)
                alert = <Alert bsStyle="danger">Timecard for the weekend {moment(tc.weekEnding).format("MM/DD/YYYY")} has been {tc.statusCode.toLowerCase()} already!</Alert>;
        }

        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-12 text-center ap-h1">
                            Verify Timecards: Details
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <Alert bsStyle="info">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Timecard ID:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6">
                                            <b>{tc ? tc.timecardId : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Week Ending:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? moment(tc.weekEnding).format("MM/DD/YYYY") : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Employee Name:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.peopleName : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Report To:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.reportToName : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Position:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.jobTitle : ""}</b>
                                        </div>
                                    </div>
                                </div>
                            </Alert>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {alert}
                            {errors}
                        </div>
                    </div>
                </div>

                <TCClockEditForm timecardId={this.props.params.timecardId} onNewTimecardAdded={this.onNewTimecardAdded} ref="tcClockEditForm"
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted} weekEnding={tc ? tc.weekEnding : null} allowEdit={allowEdit}
                    role={this.openRole} showAltered="true" hideGrid={hideGrid} />
                {buttonPanel}
            </div>
        );
    }
}
